
  import requests from "./api/base-api";

  const DiscountService = {
      getDiscountCodePrice: (body) => requests.post('/discount/v1/show-price-discountCode', body),
  
  
  }
  
  export default DiscountService
  